const campaignTable = {
  state: {
    globalSearch: {
      searchTerm: "",
    },
    orderlineID: {
      searchTerm: "",
      searchOpen: false,
    },
    advertiser: {
      searchTerm: "",
      searchOpen: false,
    },
    name: {
      searchTerm: "",
      searchOpen: false,
    },
    type: {
      filterOpen: false,
      index: {
        digital: false,
        print: false,
      },
    },
    status: {
      filterOpen: false,
      index: {
        "Awaiting delivery": false,
        "Partially delivered": false,
        "Delivered": false,
        "Copy missing": false,
        "Checked": false,
        "Sent to print": false,
        "Scheduled": false,
        "ZIP delivered": false,
        "Approved": false,
        "Rejected": false,
      },
    },
    orderBy: { key: undefined, direction: "descending" },
    currentPage: { value: "1", text: "1" },
    statusChange: 0,
    previousPage: undefined,
  },
  reducers: {
    updateSearchState: (_state, newState) => {
      return newState;
    },
    updateNavigation: (state, newValue) => {
      return { ...state, previousPage: newValue };
    },
  },
};

export default campaignTable;
